// extracted by mini-css-extract-plugin
export default {"spec":"style_spec__sURjW","specImages":"style_specImages__oGe0P"};